export enum TodoDeleOptions {
  series = 'series',
  item = 'item',
}
